import { FtfcFilterModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setupFilters/setupFiltersModules/ftfc/FtfcFilterModule';
import { FTFCBoxes } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';
import { FtfcTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setupFilters/ftfc/FtfcTacticPanel';
import { FtfcWrapper } from '../../../../components/displays/tradeplans/softOrderModules/SetupFilterModules/FTFCModule/wrapper/FtfcWrapper';
import FtfcFilterDocs from '../../../../components/forms/tradeplans/documentation/FtfcFilterDocumentation';
import { ftfcFilterParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualFilterStatusParsers/ftfc/ftfcFilterParser.ts';
import { FtfcData } from './ftfcData';
import { validateFtfc } from './validateFtfc';

export const Ftfc = {
  //data class
  dataStore: FtfcData,

  //string constants
  name: 'FTFC_FILTER',
  tacticLabel: 'FTFC Filter',
  addTacticLabel: 'Add FTFC Filter',
  category: 'Setup Filter',


  // components
  tradePlanFormModule: null,
  tacticPanel: FtfcTacticPanel,
  addTacticPanel: null,
  wrapper: FtfcWrapper,
  chartSoftOrderComponent: FTFCBoxes,
  documentation: FtfcFilterDocs,
  alertDetailsComponent: FtfcFilterModule,

  //functions
  setupDetailParser: null, //todo
  filterStatusParser: ftfcFilterParser,
  validationFunction: validateFtfc,
};
